import ReactDOM from 'react-dom';
import App from './App';

// Patch ResizeObserver to suppress benign frontend warning
const originalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends originalResizeObserver {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

ReactDOM.render(
  <App />,
  document.getElementById('root')
);